export const FIRST_TIME_DISCLAIMER_SESSION_STORAGE_KEY = 'AI_CHAT_FIRST_TIME_DISCLAIMER_ACCEPTED';
